import { useMutation, useQueryClient } from '@tanstack/react-query';
import { configCenterApi } from '../api/configCenterApi';

/**
 * DELETE /api/eraf/config-center/{key} — 설정 삭제 soft-delete (CONFIG_CENTER_WRITE)
 * 성공 시 list + categories + changes invalidate
 */
export function useDeleteConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (key: string) => configCenterApi.remove(key),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['config-center', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['config-center', 'categories'] });
      void queryClient.invalidateQueries({ queryKey: ['config-center', 'changes'] });
    },
  });
}
